
import Navbar from './footandnavbar/navbar';
import Footer from './footandnavbar/footer';
import './App.css';
import Hero from './components/hero';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Rooms from './components/pages/Rooms';
import Retreats from './components/pages/Retreats';
import Gallery from './components/pages/Gallery';
import About from './components/pages/About';
import Contact from './components/pages/Contact';
import Accommodation from './components/pages/Accommodation';
import Blog from './components/pages/Blog';
import Events from './components/pages/Events';
import Dining from './components/pages/Dining';
import FloatingButtons from './footandnavbar/FloatingButtons';
import ScrollToTop from './components/pages/ScrollToTop';
import AOS from "aos";
import "aos/dist/aos.css";
import React, { useState, useEffect } from "react";
import Loader from "./components/pages/Loader";





function App() {
  const [loading, setLoading] = useState(true);

useEffect(() => {
  const timer = setTimeout(() => {
    setLoading(false);
  }, 2000); // 2 seconds

  return () => clearTimeout(timer);
}, []);
  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  if (loading) {
  return <Loader />;
}
  return (
    <Router>
      <ScrollToTop /> 
      <Navbar />
      <FloatingButtons />
      <Routes>
        <Route path="/" element={<Hero />} />
        <Route path="/rooms" element={<Rooms />} />
        <Route path="/retreats" element={<Retreats />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/accommodation" element={<Accommodation />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/events" element={<Events />} />
        <Route path="/dining" element={<Dining />} />
       
      </Routes>

      <Footer />
    </Router>
    
  );
}


export default App;
